import { useEffect } from "react";
import Lenis from "lenis";
import { StickyHeader } from "@/components/sales/StickyHeader";
import { Hero } from "@/components/sales/Hero";
import { Marquee } from "@/components/sales/Marquee";
import { ProblemSolution } from "@/components/sales/ProblemSolution";
import { Chapters } from "@/components/sales/Chapters";
import { Author } from "@/components/sales/Author";
import { Pricing } from "@/components/sales/Pricing";
import { LeadCapture } from "@/components/sales/LeadCapture";
import { Testimonials } from "@/components/sales/Testimonials";
import { Guarantee } from "@/components/sales/Guarantee";
import { Faq } from "@/components/sales/Faq";
import { FinalCta } from "@/components/sales/FinalCta";

export default function SalesPage() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="noise-overlay bg-[#08080a] min-h-screen font-sans">
      <StickyHeader />
      <main>
        <Hero />
        <Marquee />
        <ProblemSolution />
        <Chapters />
        <Pricing />
        <Author />
        <Testimonials />
        <Guarantee />
        <LeadCapture />
        <Faq />
        <FinalCta />
      </main>
    </div>
  );
}
